import React, { useState, useMemo } from 'react';
import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../components/useTable/UsePaginator';
import _ from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { setDebitor, displayForms } from '../../../reduxStore/newCase/newCaseActions';
import KredittvurderingDebitorList from './KredittvurderingDebitorList';
import InfoAndDeactivate from './InfoAndDeactivate';
import KredittvurderingSearchHistory from './KredittvurderingSearchHistory';
import KredittvurderingRatingForm from './KredittvurderingRatingForm';
import { Alert } from 'react-bootstrap';

const KredittvurderingViewComponent = (props) => {
    const localeMessages = props.localeMessages
    // const newCaseState = props.newCaseState
    const kredittvurderingState = props.state
    // const tableData = newCaseState.debitorList
    const ratingInfoData = props.ratingInfoData !== undefined ? props.ratingInfoData : []
    const searchDataList = props.searchHistoryList;
    const newCaseState = useSelector(state => state.newCase)
    newCaseState.displayForm = displayForms.DEBITORFILTER;
    const crState = useSelector(state => state.sakslisteHeader)

    const _dispatch = useDispatch()

    // // State for grid sorting
    // const [currentSeq, setCurrentSeq] = useState('up'); // default
    // const [currentField, setCurrentField] = useState('debtorName');    // feltnavn
    // const [currentType, setCurrentType] = useState('string'); // num
    // const [sortClicked, setSortClicked] = useState(0);

    // const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
    //     currentSeq, setCurrentSeq,
    //     currentField, setCurrentField,
    //     currentType, setCurrentType
    // )

    // // Nødvendig pga henting av memoised felt
    // const t1ChangeSortField = (fieldName, fieldType) => {
    //     masterT1ChangeSortField(fieldName, fieldType)

    //     // Sett trigger for å tvinge memoized function til rerender
    //     setSortClicked(Date.now())
    // }

    // state for grid paginator
    // const [numberPrPage, setNumberPerPage] = useState(10)
    // const [activePage, setActivePage] = useState(1);
    // const [showAll, setShowAll] = useState(false);

    // const memoizedCasesForTable = useMemo(
    //     () => {
    //         if (newCaseState.debitorListFiltered.length > 0) {
    //             return [...newCaseState.debitorListFiltered].sort(t1GetSortFunc().fn)
    //         }
    //         else {
    //             return []
    //         }
    //     },
    //     [newCaseState.debitorListFiltered, sortClicked]
    // );

    // const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
    //     memoizedCasesForTable,
    //     numberPrPage, setNumberPerPage,
    //     activePage, setActivePage
    // )

    const selectDebitor = (debitor) => {
        _dispatch(setDebitor(debitor))
    }

    return (
        <>
            {kredittvurderingState.ratingError && (<Alert variant='danger'>{kredittvurderingState.ratingError}</Alert>)}
            <KredittvurderingRatingForm
                state={newCaseState}
                kredittvurderingState={kredittvurderingState}
                localeMessages={localeMessages}
                selectDebitor={selectDebitor}
                getChosenRating={props.getChosenRating}
                clearRatingData={props.clearRatingData}
            />
            <br/>
            {/* <KredittvurderingDebitorList
                state={newCaseState}
                kredittvurderingState={kredittvurderingState}
                localeMessages={localeMessages}
                PaginationDropdown={PaginationDropdown}
                t1IndicaterIcon={t1IndicaterIcon}
                t1ChangeSortField={t1ChangeSortField}
                Paginate={Paginate}
                PaginationIndex={PaginationIndex}
                PaginationNav={PaginationNav}
                selectDebitor={selectDebitor}
                numberPrPage={numberPrPage}
                clearRatingData={props.clearRatingData}
            />
            <br/> */}
            <KredittvurderingSearchHistory
                localeMessages={localeMessages}
                state={kredittvurderingState}
                ratingInfoData={ratingInfoData}
                searchHistoryData={searchDataList}
                selectDebitor={selectDebitor}
                getRatingInfo={props.getRatingInfo}
            />
            <br/>
            <InfoAndDeactivate
                newCaseState={newCaseState}
                state={kredittvurderingState}
                localeMessages={localeMessages}
                selectDebitor={selectDebitor}
                ratingInfoData={ratingInfoData}
                termsModal={props.termsModal}
                deactivateModal={props.deactivateModal}
            />
            <br/>
        </>
    )
}

export default KredittvurderingViewComponent